import React from 'react'
import moment from 'moment'
import lang from '@/lang'

import WebStorageService from '@/modules/_services/webstorage.service'
import WebStorageKey from '@/enums/web-storage-key.enum'

import config from '@/config'
import IconCheck from '@assets/images/icons/check.svg'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons/index'
import TrialExpired from '@assets/images/trial-expired.svg?url'
import Background from '@assets/images/trial-expired-bg.svg'
import Logo from '@assets/images/logo/svg/product-logo.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

import { withStyles } from '@mui/styles'
import { fetchSubscriptionData } from '@/redux/ducks/subscription/details'
import { orderBy } from 'lodash'

class SubscriptionExpiredView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      subscriptions: [],
    }
    this.onReadOnlyButtonClick = this.onReadOnlyButtonClick.bind(this)
  }

  componentWillMount() {
    fetchSubscriptionData(false, data => {
      const { subscriptions } = data
      this.setState({ subscriptions })
    })
  }

  onReadOnlyButtonClick() {
    const { onAbort } = this.props
    WebStorageService.setItem(WebStorageKey.READ_ONLY_CONFIRMED, true)
    onAbort()
  }

  render() {
    const { subscriptions } = this.state
    const { onUpgradeClick } = this.props
    const isTrial = subscriptions?.some(s => s.isTrial === false)
    const { end } = orderBy(subscriptions, ['end'], ['desc'])[0] || {}
    const endDate = moment(end).format(config.dateFormat.client)

    const { classes, firstName, lastName } = this.props

    const greeting = lang.upgradeModal.greetingText(firstName, lastName)

    const text = isTrial
      ? lang.upgradeModal.trialExpiredAt(endDate)
      : lang.upgradeModal.subscriptionExpiredAt(endDate)

    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <SVGIcon svg={Logo} customClass={classes.logo} />
          <p className={classes.greeting}>{greeting}</p>
          <p className={classes.text}>{text}</p>
          <p className={classes.longText}>{lang.upgradeModal.trialExpirationText}</p>
          {lang.upgradeModal.upgradePerks.map((perk, i) => (
            <div className={classes.textLine}>
              <SVGIcon svg={IconCheck} customClass={classes.checkIcon} fill={'#89c958'} />
              <p className={classes.perkText} style={{ fontWeight: `${i === 4 ? '500' : '400'}` }}>{perk}</p>
            </div>
          ))}
          <div className={classes.buttonContainer}>
            <ButtonIconSquare label={lang.upgradeModal.upgradeNow} onClick={onUpgradeClick} customClass={classes.upgradeButton} />
            <CancelButton key='readOnlyButton' label={lang.account.readonlyMode} customClass={classes.cancelButton} onClick={this.onReadOnlyButtonClick} />
          </div>
        </div>
        <div className={classes.svgContainer}>
          <SVGIcon svg={Background} customClass={classes.backgoundSvg} />
          <SVGIcon svg={TrialExpired} customClass={classes.trialExpiredSvg} height='70%' width='50%' />
        </div>
      </div>
    )
  }
}

const styles = (theme) => ({
  container: {
    height: 610,
    overflow: 'hidden',
    maxHeight: '100%',
    display: 'flex',
    margin: 0,
    color: theme.black,
  },
  content: {
    height: '100%',
    width: 640,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  logo: {
    height: 38,
    width: '100%',
    margin: '55px 0 0 0',
    display: 'flex',
    justifyContent: 'center',
  },
  greeting: {
    fontSize: 26,
    margin: '20px 0',
  },
  text: {
    fontSize: 14,
    margin: '0 0 40px 0',
  },
  longText: {
    fontWeight: 600,
    margin: '0 0 20px 0',
  },
  textLine: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    height: 'fit-content',
    marginBottom: 20,
    '& .textLine:last-of-type': {
      border: '1px solid',
    },
  },
  perkText: {
    margin: 0,
    '& >p': {
      border: '1px solid',
      '&:last-of-type': {
        border: '1px solid',
      },
    },
  },
  checkIcon: {
    height: 10,
    width: 13.2,
    marginRight: 10,
  },
  svgContainer: {
    height: '100%',
    width: 410,
  },
  trialExpiredSvg: {
    position: 'absolute',
    top: 86,
    right: 0,
  },
  buttonContainer: {
    width: 211,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0 40px 0',
  },
  upgradeButton: {
    width: '100%',
    margin: 0,
  },
  cancelButton: {
    border: 'none',
    color: theme.colorPrimaryButtonBackground,
    margin: '20px 0 0 0',
    height: 17,
    width: 'fit-content',
    '&:hover': {
      background: 'transparent !important',
    },
  },
})

export default withStyles(styles, { withTheme: true })(SubscriptionExpiredView)
